import { useGetList } from "ra-core";
import { useMemo } from "react";
import type { ProductMissionKey } from "../domain/training/missions";
import type { QuizQuestion } from "./content/types";
import {
  catalogQuestions,
  type CatalogAddonLike,
  type CatalogPackageLike,
} from "./content/product/catalogQuestions";
import { STATIC_QUESTIONS } from "./content/product/staticQuestions";

const LIST = {
  pagination: { page: 1, perPage: 1000 },
  sort: { field: "position", order: "ASC" as const },
};

/** Questions per product mission; null while the catalog is loading or unusable. */
export function useProductQuestions(): Record<
  ProductMissionKey,
  readonly QuizQuestion[]
> | null {
  const packages = useGetList<CatalogPackageLike>("packages", LIST);
  const addons = useGetList<CatalogAddonLike>("package_addons", LIST);
  return useMemo(() => {
    if (
      packages.isPending ||
      addons.isPending ||
      packages.isError ||
      addons.isError
    )
      return null;
    const c = catalogQuestions(packages.data ?? [], addons.data ?? []);
    return {
      ...STATIC_QUESTIONS,
      product_pricing: c.pricing,
      product_addons:
        c.addonPrices.length > 0
          ? [...c.addonPrices, ...STATIC_QUESTIONS.product_addons]
          : [],
    };
  }, [
    packages.isPending,
    packages.isError,
    packages.data,
    addons.isPending,
    addons.isError,
    addons.data,
  ]);
}
